/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GenLocationsServiceRequest
 */
export interface GenLocationsServiceRequest {
  /**
   *
   * @type {number}
   * @memberof GenLocationsServiceRequest
   */
  regionId: number
  /**
   *
   * @type {number}
   * @memberof GenLocationsServiceRequest
   */
  serviceId: number
}

/**
 * Check if a given object implements the GenLocationsServiceRequest interface.
 */
export function instanceOfGenLocationsServiceRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'regionId' in value
  isInstance = isInstance && 'serviceId' in value

  return isInstance
}

export function GenLocationsServiceRequestFromJSON(json: any): GenLocationsServiceRequest {
  return GenLocationsServiceRequestFromJSONTyped(json, false)
}

export function GenLocationsServiceRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenLocationsServiceRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    regionId: json['regionId'],
    serviceId: json['serviceId'],
  }
}

export function GenLocationsServiceRequestToJSON(value?: GenLocationsServiceRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    regionId: value.regionId,
    serviceId: value.serviceId,
  }
}
